import { MAP_LAYER_TYPES } from '../../components/Map/Utils/layerTypes';

// layers to activate on map
export const LAYERS = [
  MAP_LAYER_TYPES.assets,
  MAP_LAYER_TYPES.basins,
  MAP_LAYER_TYPES.blocks,
  MAP_LAYER_TYPES.eaWells,
  MAP_LAYER_TYPES.facilities,
  MAP_LAYER_TYPES.fields,
  MAP_LAYER_TYPES.formations,
  MAP_LAYER_TYPES.leases,
  MAP_LAYER_TYPES.lng,
  MAP_LAYER_TYPES.pipelines,
  MAP_LAYER_TYPES.pipelineNetworks,
  MAP_LAYER_TYPES.pipelineSegments,
  MAP_LAYER_TYPES.presaltPolygons,
  MAP_LAYER_TYPES.screening,
  MAP_LAYER_TYPES.wells,
];

// Labels for the layers
// ENTITIES
export const ASSETS_LABEL = 'Assets';
export const BASINS_LABEL = 'Basins';
export const BLOCKS_LABEL = 'Blocks';
export const EA_WELLS_LABEL = 'E&A Wells to Watch';
export const FACILITIES_LABEL = 'Facilities';
export const FIELDS_LABEL = 'Fields';
export const LNG_FACILITIES_LABEL = 'LNG';
export const PIPELINES_LABEL = 'Pipelines';
export const PIPELINE_SEGMENTS_LABEL = 'Pipeline Segments';
export const WELLS_LABEL = 'Wells';
export const OTHER_LABEL = 'Other';

// ENTITY TYPES
export const EXPLORATION_LABEL = 'Exploration';
export const GAS_LABEL = 'Gas';
export const INJECTION_LABEL = 'Injection';
export const DISCOVERY_LABEL = 'Discovery';
export const LICENSED_LABEL = 'Licensed';
export const LIQUEFACTION_LABEL = 'Liquefaction';
export const OIL_LABEL = 'Oil';
export const PRODUCTION_LABEL = 'Production';
export const PRODUCTS_LABEL = 'Products';
export const REGASIFICATION_LABEL = 'Regasification';
export const UNLICENSED_LABEL = 'Unlicensed';

// LABEL TYPES
export const LABEL = 'Labels';
export const OPERATOR_LABEL = 'Operator Labels';
